<template>
  <l-feature-group name="us-faults">
    <l-geo-json
      :geojson="usFaults"
      :options="usFaultsOptions"
      :options-style="usFaultsStyle"
      />
    <l-feature-group name="us-faults-wrapped" v-if="wrappedMarkers">
      <l-geo-json
        :geojson="usFaults"
        :options="usFaultsOptionsLeft"
        :options-style="usFaultsStyle"
        />
      <l-geo-json
        :geojson="usFaults"
        :options="usFaultsOptionsRight"
        :options-style="usFaultsStyle"
        />
    </l-feature-group>
  </l-feature-group>
</template>

<script>
  console.log("import usFaultsData started")
  import usFaultsData from '@/assets/json-files/ca_nv_faults.json'

  export default {
    props: ['wrappedMarkers', 'usFaultsOptions', 'usFaultsOptionsLeft', 'usFaultsOptionsRight', 'usFaultsStyle'],
    data: function() {
      console.log("usFaultsData import finished")
      return {
        usFaults: usFaultsData,
      }
    }
  }
</script>
